import React, { useState, useEffect } from 'react';
import '../../css/notificationsSettings.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import Heading from '../../components/Heading';
import CustomBreadcrumbsSettings from '../../components/Breadcrumbs/CustomBreadcrumbsSettings';
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setMudaStatusNoti } from '../../features/onboardingData/onboardingUserData';
import { errorHandling } from '../../utils';
import SuspendedWalletAlert from '../../components/SuspendedWalletAlert';

function NotificationsSettings() {

    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isMudaStatusNoti = useSelector((state) => state.onboardingUserData.isMudaStatusNoti);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [isSwitch, setIsSwitch] = useState(true);
    const [statusNoti, setStatusNoti] = useState('S');

    const handleSwitchChange = () => {
        dispatch(setMudaStatusNoti(!isMudaStatusNoti));
        setStatusNoti(isMudaStatusNoti == true ? 'S' : 'N')
        postMudaStatusNoti();
    };
    const hadleBtnClickDeleteWallet = () => {
        navigate('/configuracoes/desligar-carteira');
    };

    const handleSaudeEmailClick = () => {
        const emailAddress = 'geral@saude360.medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleMarketPlaceEmailClick = () => {
        const emailAddress = 'marketplace@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const handleActiveEmailClick = () => {
        const emailAddress = 'active@medis.pt';
        const mailtoLink = `mailto:${emailAddress}`;
    
        window.location.href = mailtoLink;
    }

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const postMudaStatusNoti = async () => {
        try {
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/mudaStatusNoti/fetchMudaStatusNoti`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                "xsrf-token": csrfToken,
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({ statusNoti: isMudaStatusNoti == true ? 'N' : 'S' }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            // if (result.erroMsg === 'Success') {
            //     dispatch(setMudaStatusNoti(isSwitch));
            // }
        } catch (error) {
           if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
        ))(({ theme }) => ({
            width: 42,
            height: 26,
            padding: 0,
            '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#15D4B6' : '#15D4B6',
                opacity: 1,
                border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
            },
            '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
            },
            '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#14141429' : '#14141429',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const handleBtnCall = () => {
        const phoneNumber = '218458888';
        window.location.href = `tel:${phoneNumber}`;
    };

    const handleBtnGoToContacts = () => {
        const element = document.getElementById('contactMainContainerNotificationsSettings');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (  
        <>
        <Header/> 
        <div className={ isTablet ? "mainViewContainerNotificationsSettings" : ( isMobile ? 'mainViewContainerNotificationsSettingsTablet' : 'mainViewContainerNotificationsSettingsMobile') }>
            <div className={ isTablet ? 'firstTxtViewContainerNotificationsSettings' : ( isMobile ? 'firstTxtViewContainerNotificationsSettingsTablet' : 'firstTxtViewContainerNotificationsSettingsMobile') }>
                <div style={ isTablet ? { width: '100%', height: '100%', marginBottom: '48px', marginTop: '-48px' } :  ( isMobile ? { width: '100%', height: '100%', paddingInline: '40px', paddingTop: '-48px' } : { width: '100%', height: '100%', paddingInline: '16px' })}>
                    { (isStatusCarteira ===  '2')  &&
                        <SuspendedWalletAlert onPress={handleBtnGoToContacts} />
                    }
                </div>
                <div className='mainHeadingViewContainerNotificationsSettings'> 
                    <CustomBreadcrumbsSettings hasPadding hasSettings hasNotifications />
                    <Heading hasPadding hasBtnBack={false}/>
                </div>
                <div className={ isTablet ? 'secondMainContainerNotificationsSettings' : ( isMobile ? 'secondMainContainerNotificationsSettingsTablet' : 'secondMainContainerNotificationsSettingsMobile') }>
                    <div className={ isTablet ? 'firstSubMainContainerNotificationsSettings' : 'firstSubMainContainerNotificationsSettingsMobile' }>
                        <div className='secondTitleViewNotificationsSettings'>
                            <div className={ isTablet ? 'textTitleRegular400NotificationsSettings' : ( isMobile ? 'textTitleRegular400NotificationsSettingsTablet' : 'textTitleRegular400NotificationsSettingsMobile') }>Notificações</div>
                        </div>
                        <div className='txtSecondTitleViewNotificationsSettings'>
                            <div className='textSecondTitleViewNotificationsSettings'>Avisos de acumulação de saldo</div>
                        </div>
                    </div>
                </div>
                
                <div className={ isTablet ? 'secondMainContainerTwoNotificationsSettings' : ( isMobile ? 'secondMainContainerTwoNotificationsSettingsTablet' : 'secondMainContainerTwoNotificationsSettingsMobile' )}>
                    <div className={ isTablet ? 'textSecondContainerTitleViewNotificationsSettings' : ( isMobile ? 'textSecondContainerTitleViewNotificationsSettingsTablet' : 'textSecondContainerTitleViewNotificationsSettingsMobile' )}>
                        <div className='textSecondContainerTitleNotificationsSettings'>Tenha a confirmação de que acumulou saldo na Carteira Virtual, recebendo um SMS após cada acumulação.</div>
                    </div>
                    <div className={ isTablet ? 'secondMainContainerTwoRowNotificationsSettings' : ( isMobile ? 'secondMainContainerTwoRowNotificationsSettingsTablet' : 'secondMainContainerTwoRowNotificationsSettingsMobile' )}>
                    <div className='textSecondTitleViewNotificationsSettings'>Receber SMS</div>
                    <FormControlLabel
                        control={<IOSSwitch sx={{ m: 1 }} />}
                        checked={isMudaStatusNoti}
                        onChange={handleSwitchChange}
                    />
                    </div>
                </div>   
            </div>
            <div id='contactMainContainerNotificationsSettings' className={ isTablet ? 'secondMainViewContainerNotificationsSettings' : ( isMobile ? 'secondMainViewContainerNotificationsSettingsTablet' : 'secondMainViewContainerNotificationsSettingsMobile' ) }>
                <div className='infroMainCardViewNotificationsSettings'>
                    <div className='contactInfoBoxRowViewNotificationsSettings'>
                        <div className='emailIconSvgInfoBoxViewNotificationsSettings'><MdOutlineMail className='emailIconSvgInfoBoxNotificationsSettings' /></div>
                        <div className='txtRegularInfoBoxNotificationsSettings'>Email <span className='txtSemiBoldInfoBoxNotificationsSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='contactInfoBoxColumnViewNotificationsSettings'>
                        <div className='txtEmailRegularInfoBoxNotificationsSettings'>geral@saude360.medis.pt</div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewNotificationsSettings' : 'btnInfoBoxViewNotificationsSettingsMobile'}>
                        <CustomButton 
                            text={'Enviar email'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'email'}
                            onPress={handleSaudeEmailClick}
                        />
                    </div>
                </div>
                <div className='infroMainCardViewNotificationsSettings'>
                    <div className='contactInfoBoxRowViewNotificationsSettings'>
                        <div className='emailIconSvgInfoBoxViewNotificationsSettings'><MdOutlinePhoneInTalk className='emailIconSvgInfoBoxNotificationsSettings' /></div>
                        <div className='txtRegularInfoBoxNotificationsSettings'>Telefone <span className='txtSemiBoldInfoBoxNotificationsSettings'>Médis Saúde 360</span></div>
                    </div>
                    <div className='mainSecondContactInfoBoxColumnViewNotificationsSettings'>
                        <div className='txtEmailSemiBoldInfoBoxNotificationsSettings'>210 204 887</div>
                        <div className='contactInfoBoxColumnViewNotificationsSettings'>
                            <div className='txtEmailRegularInfoBoxNotificationsSettings'>De segunda a sexta, das 9h às 18h.</div>
                            <div className='txtEmailRegularInfoBoxNotificationsSettings'>Custo de chamada para rede fixa nacional.</div>
                        </div>
                    </div>
                    <div className={ isTablet ? 'btnInfoBoxViewNotificationsSettings' : 'btnInfoBoxViewNotificationsSettingsMobile'}>
                        <CustomButton 
                            text={'Ligar'} 
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            hasShadow={false}
                            hasArrow
                            iconColor={'#141414'}
                            iconType={'phone'}
                            onPress={handleBtnCall}
                        />
                    </div>
                </div>
            </div>
            <div className={ isTablet ? 'thirdMainViewContainerNotificationsSettings' : ( isMobile ? 'thirdMainViewContainerNotificationsSettingsTablet' : 'thirdMainViewContainerNotificationsSettingsMobile' )}>
                <div className='titleMainViewThirdContainerNotificationsSettings'>
                    <div className='txtTitleThirdContainerNotificationsSettings'>Apagar carteira virtual</div>
                    <div className='txtThirdContainerNotificationsSettings'>Pode apagar a sua carteira Médis a qualquer momento.</div>
                </div>
                <div className='btnThirdContainerNotificationsSettings'>
                    <CustomButton 
                        text={'Apagar Carteira'} 
                        textColor={'#00214D'}
                        borderColor={'#00214D'}
                        hasShadow={false}
                        onPress={hadleBtnClickDeleteWallet}
                    />
                </div>
            </div>
        </div>
        <Footer/> 
        </>
    )
}

export default NotificationsSettings;